import React from 'react';

import copy from 'copy-to-clipboard';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Toast } from '@whelk/components';
import { setContactPageOpen } from '@whelk/store/slices/layoutSlice';
import { openUrl } from '@whelk/utils';
import { RootState } from '@whelk/store';
import PlainModal from '@whelk/components/src/Base/PlainModal';
import { ContactCopyIcon, ContactLinkIcon } from '@whelk/assets/src/web/common-icons';

import { isOverseas } from '@whelk/const/src/env';

export const EMAIL = isOverseas ? 'contact@minimax.io' : 'feedback-chat@minimaxi.com';

function ContactModal() {
  const show = useSelector((state: RootState) => state.layout.contactPageOpen);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onCopy = (text: string) => {
    copy(text);
    Toast.success(t('toast_copied'));
  };

  const onClose = () => {
    dispatch(setContactPageOpen(false));
  };

  return (
    <PlainModal
      open={show}
      onClickMask={onClose}
      onClose={onClose}
      title={t('contact_us')}
      size='md'
    >
      <div className='bg-col_bg09 text-col_text00 space-y-3 text-base'>
        <div className='bg-col_bg00 rounded-xl p-4'>
          <div className='text-col_text02 mb-2 text-[14px] font-medium'>{t('offical_email')}</div>
          <div className='desc text-col_text00 flex items-center'>
            {EMAIL}
            <div
              onClick={() => onCopy(EMAIL)}
              className='md:hover:bg-orn_hover ml-1.5 cursor-pointer rounded p-0.5'
            >
              <ContactCopyIcon />
            </div>
          </div>
        </div>

        {!isOverseas && (
          <>
            <div className='bg-col_bg00 rounded-lg p-4'>
              <div className='text-col_text02 mb-2 text-[14px] font-medium'>{t('report_inap')}</div>
              <div
                className='text-col_text00 flex cursor-pointer items-center'
                onClick={() => {
                  openUrl(
                    'https://biaodan.info/web/formview/63da2813fc918f7b3df14f6e',
                    true,
                    '_blank',
                  );
                }}
              >
                <span>
                  <ContactLinkIcon />
                </span>
                <span className='ml-1.5'>{t('click_rep_pag')}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </PlainModal>
  );
}

export { ContactModal };
